import { Pipe, PipeTransform } from '@angular/core';
import { ContentService } from '@blk/cwp-ng-framework';
import { PortfolioType } from '@ddt-web/config';
import * as dayjs from 'dayjs';

@Pipe({
	name: 'portfolioDisplayDate'
})
export class PortfolioDisplayDatePipe implements PipeTransform {

	constructor(private contentService: ContentService) { }

	public transform(inputDate: string | number, portfolioType: string): string {
		let date = null;
		if (portfolioType === PortfolioType.PORTFOLIO) {
			date = this.getLastModified(Number(inputDate));
		} else if (portfolioType === PortfolioType.MODEL) {
			date = this.getBlkModelDateFormat(String(inputDate));
		} else if (portfolioType === PortfolioType.THIRD_PARTY) {
			date = this.getThirdPartyModelDateFormat(String(inputDate));
		}
		return date;
	}

	public getThirdPartyModelDateFormat(dateString: string): string {
		const dateFormat = this.contentService.get('THIRD_PARTY_ALLOCATION_DATE_FORMAT', 'MM/DD/YYYY [Allocations]');
		return dayjs(dateString, ['MM/DD/YYYY', 'YYYYMMDD'], true).format(dateFormat);
	}

	public getBlkModelDateFormat(dateString: string): string {
		const dateFormat = this.contentService.get('MP_ALLOCATION_DATE_FORMAT', 'MM/DD/YYYY [Allocations]');
		return dayjs(dateString, ['MM/DD/YYYY', 'YYYYMMDD'], true).format(dateFormat);
	}

	public getLastModified(dateMs: number): string {
		return this.contentService.getSubstitutedValuesString(
			'HOLDINGS_USER_PORTFOLIO_HEADER',
			new Map([['{1}', dayjs(dateMs).format('MM/DD/YYYY')]]),
			'Last updated<br>{1}'
		);
	}
}
